// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin › Projects list. */

.admin-projects__name {
  font-weight: 600;
  overflow-wrap: anywhere;
}

.admin-projects__status {
  min-width: 140px;
}
`, "",{"version":3,"sources":["webpack://./src/admin/components/projects/AdminProjects.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* Admin › Projects list. */\n\n.admin-projects__name {\n  font-weight: 600;\n  overflow-wrap: anywhere;\n}\n\n.admin-projects__status {\n  min-width: 140px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
